class LazyLoad {
  constructor() {
    this.initLazyLoad();
  }

  initLazyLoad() {
    // if 'loading' supported
    if (!('loading' in HTMLImageElement.prototype) && Boolean(window.IntersectionObserver)) {
      return;
    }

    const selectors = {
      imgContainer: '.lazyimage',
      lazyImg: 'img[loading="lazy"]',
    };

    const classes = {
      imageLoaded: 'lazyimage--loaded',
      imageError: 'lazyimage--error',
      imageErrorShow: 'lazyimage--error-show',
    };

    const lazyImageLoad = (entry) => {
      entry.parentNode.classList.add(classes.imageLoaded);
    };

    const lazyImageError = (evt) => {
      const parent = evt.currentTarget.parentNode;
      parent.classList.remove(classes.imageLoaded);
      parent.classList.add(classes.imageError);
      setTimeout(() => {
        parent.classList.add(classes.imageErrorShow);
      }, 60);
    };

    const checkVisible = (element) => {
      // Returns `true` if the element is visible on the page.
      const rect = element.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    const lazyImages = document.querySelectorAll(`${selectors.imgContainer} ${selectors.lazyImg}`);

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.target.complete) {
            if (entry.target.complete) {
              lazyImageLoad(entry.target);
            }
            entry.target.addEventListener('error', lazyImageError, false);
            observer.unobserve(entry.target);
          }
        }
      }, {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      },
    );

    lazyImages.forEach((img) => {
      observer.observe(img);
    });

    // Check if image is visible on page load.
    document.addEventListener('DOMContentLoaded', () => {
      lazyImages.forEach((img) => {
        const isVisible = checkVisible(img);
        if (isVisible) {
          lazyImageLoad(img);
        }
      });
    });

    // Update images when section is rebuilt.
    document.addEventListener('shopify:section:load', () => {
      lazyImages.forEach((img) => {
        const isVisible = checkVisible(img);
        if (isVisible) {
          lazyImageLoad(img);
        }
      });
    });
  }
}

export default LazyLoad;
